import * as api from '../../../../api';

import { useTranslation } from 'react-i18next';
import { VStack, Dialog, Icon } from '@vivaahealth/design-system';
import { FormikProps } from 'formik';

import EmergencyContactButton from '../EmergencyContactButton';

import { EditEmergencyContactValues } from './schema';

interface EmergencyContactConfirmationDialogProps {
  emergencyContact: {
    newRank: number;
  };
  dialog: {
    description: string;
    title: string;
    isOpen: boolean;
    onClose: () => void;
    isRemoveExperience?: boolean;
  };
  formikProps: FormikProps<EditEmergencyContactValues>;
}

const EmergencyContactConfirmationDialog = (
  props: EmergencyContactConfirmationDialogProps,
) => {
  const { t } = useTranslation('emergencyContacts');

  const {
    dialog: { title, description, onClose, isOpen, isRemoveExperience = false },
    emergencyContact: { newRank },
    formikProps: { submitForm, setFieldValue },
  } = props;

  const controls = isRemoveExperience ? (
    <>
      <EmergencyContactButton
        variant="primary"
        colorVariant={'danger'}
        message={t('remove', { ns: 'common' })}
        onClickHandler={() => {
          setFieldValue('status', api.Previsit.ModificationStatus.Removed);
          submitForm();
        }}
      />
      <EmergencyContactButton
        variant="outlined"
        colorVariant={'secondary'}
        message={t('cancel', { ns: 'common' })}
        onClickHandler={onClose}
      />
    </>
  ) : (
    <>
      <EmergencyContactButton
        variant="primary"
        message={t('addAsNewContact')}
        onClickHandler={() => {
          setFieldValue('rank', newRank);
          setFieldValue('status', api.Previsit.ModificationStatus.Added);
          submitForm();
        }}
      />
      <EmergencyContactButton
        variant="primary"
        message={t('updateExistingContact')}
        onClickHandler={submitForm}
      />
    </>
  );

  return (
    <Dialog
      open={isOpen}
      Icon={<Icon.AlertTriangle size="large" color="#ffae00" />}
      description={description}
      title={title}
      onClose={onClose}
    >
      <VStack gap={20} width={'100%'}>
        {controls}
      </VStack>
    </Dialog>
  );
};

export default EmergencyContactConfirmationDialog;
